import {NOTIFICATION_TYPES, OPERATIONS, SECTIONS} from "../../../../config/constants";
import PageHead from "../../../layout/PageHead";
import {Button, Checkbox, message, Modal, Select, Tabs} from "antd";
import "./ValidationRules.css";
import { useSearchParams } from "react-router-dom";
import ValidationMapping from "./components/ValidationMapping";
import Rules from "./components/ValidationRules";
import { useEffect, useState } from "react";
import TablesService from "../../../../services/tables/TablesService";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import FieldMappingsService from "../../../../services/fieldmappings/FieldMappingsService";
import { ReconciliationOutlined, PlusOutlined, ApartmentOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../../../config/consts/routes";
import {CopyBulkFieldMappingRequest} from "../../../../models/fieldmappings/CopyBulkFieldMappingRequest";
import NotificationsUtil from "../../../shared/utils/NotificationsUtil";

const { TabPane } = Tabs;

const routes = [
  {
    path: ROUTES.general.main.name,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.operation.name,
  },
  {
    path: ROUTES.operation.validationRules.route,
    breadcrumbName: ROUTES.operation.validationRules.name,
  },
];

const ValidationRules = () => {
  const { t, i18n } = useTranslation("translations");

  const [searchParams, setSearchParams] = useSearchParams();

  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>(null);
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();
  const [newValidationRuleModalEnabled, setNewValidationRuleModalEnabled] = useState(false);
  const [automapValidationMappingModalEnabled, setAutomapValidationMappingModalEnabled] = useState(false);
  const [copyMappingsModalEnabled, setCopyMappingsModalEnabled] = useState(false);
  const [copyMappingSourceGroupCode, setCopyMappingSourceGroupCode] = useState<any>(null);
  const [copyMappingTargetGroupCode, setCopyMappingTargetGroupCode] = useState<any>(null);
  const [overwriteExistingMappings, setOverwriteExistingMappings] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = ROUTES.operation.validationRules.name;
  }, []);

  useEffect(() => {
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    TablesService.getAllOperations().then((response: any) => {
      const data = response.data;
      setOperations(data);
    });
  }, []);

  useEffect(() => {
    if (operations) {
      setSelectedOperation(OPERATIONS.VALIDATION)
    }
  }, [operations]);

  const onChange = (key: string) => {
    searchParams.set("tab", key);
    setSearchParams(searchParams);
  };

  const handleNewValidationRuleButtonClick = (
      e: React.MouseEvent<HTMLButtonElement>
  ) => {
    setNewValidationRuleModalEnabled(true);
  };

  const handleAutomapValidationMappingButtonClick = (
      e: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAutomapValidationMappingModalEnabled(true);
  };

    const handleCopyMappingsOk = async () => {
        setLoading(true);

        const model: CopyBulkFieldMappingRequest = {
            fromGroupCode: selectedGroupCode,
            toGroupCode: copyMappingTargetGroupCode,
            entity: entities.find(x => x.id == selectedEntity)?.name,
            overwriteExistingMappings: overwriteExistingMappings,
        };

        try {
            await FieldMappingsService.copyBulk(model);
            setLoading(false);
            setCopyMappingsModalEnabled(false);
            NotificationsUtil.openNotificationDialog({
                description: "Copy validation mappings has been successfully completed.",
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
            });
        } catch (error) {
            setLoading(false);
            NotificationsUtil.openNotificationDialog({
                description: "Error copying bulk: " + error.message,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        }
    };

  const handleCopyMappingsButtonClick = (
      e: React.MouseEvent<HTMLButtonElement>
  ) => {
    setCopyMappingsModalEnabled(true);
    setCopyMappingSourceGroupCode(selectedGroupCode);
  };

  const validationMappingActionButton = (
      <>
        <Button
            type={"primary"}
            onClick={handleAutomapValidationMappingButtonClick}
            style={{ borderColor: "var(--white)" }}
        >
          <ApartmentOutlined />
          {t(
              "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.Automap",
              {
                lngs: i18n.languages,
                defaultValue: "AUTOMAP",
              }
          )}
        </Button>
        <Button
            type={"primary"}
            onClick={handleCopyMappingsButtonClick}
            style={{ borderColor: "var(--white)", marginLeft: "10px" }}
        >
          <ApartmentOutlined />
          {t(
              "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.CopyMappings",
              {
                lngs: i18n.languages,
                defaultValue: "COPY MAPPINGS",
              }
          )}
        </Button>
      </>
  );

  const validationRulesActionButton = (
      <Button
          type={"primary"}
          onClick={handleNewValidationRuleButtonClick}
          style={{ borderColor: "var(--white)" }}
      >
        <PlusOutlined />
        {t(
            "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.ActionNew",
            {
              lngs: i18n.languages,
              defaultValue: "NEW RULE",
            }
        )}
      </Button>
  );
  
  return (
      <div>
        <PageHead
            title={ROUTES.operation.validationRules.name}
            icon={<ReconciliationOutlined />}
            routes={routes}
            groupCodes={groupCodes}
            entities={entities}
            operations={operations}
            selectedGroupCode={selectedGroupCode}
            selectedEntity={selectedEntity}
            selectedOperation={selectedOperation}
            setSelectedGroupCode={setSelectedGroupCode}
            setSelectedEntity={setSelectedEntity}
            setSelectedOperation={setSelectedOperation}
            setSelectGroupCodeDisabled={
              searchParams.get("tab") &&
              searchParams.get("tab") === "validation-mapping"
                  ? false
                  : searchParams.get("tab") &&
                  searchParams.get("tab") === "validation-rules"
                      ? false
                      : false
            }
            setSelectEntityDisabled={
              searchParams.get("tab") &&
              searchParams.get("tab") === "validation-mapping"
                  ? false
                  : searchParams.get("tab") &&
                  searchParams.get("tab") === "validation-rules"
                      ? false
                      : true
            }
            setSelectOperationDisabled={true}
            mainAction={
              searchParams.get("tab") &&
              searchParams.get("tab") === "validation-mapping"
                  ? validationMappingActionButton
                  : searchParams.get("tab") &&
                  searchParams.get("tab") === "validation-rules"
                      ? validationRulesActionButton
                      : true
            }
            otherActions={[]}
            setActionsDisabled={false}
        />
        <div className="card-container">
          <Tabs
              type="card"
              activeKey={searchParams.get("tab") ? searchParams.get("tab")! : ""}
              onTabClick={onChange}
              style={{ height: "100%" }}
          >
            <TabPane
                tab={t("Page.Operation.ValidationRules.Tabs.ValidationMapping", {
                  lngs: i18n.languages,
                  defaultValue: "Validation Mapping",
                })}
                key="validation-mapping"
            >
              <ValidationMapping
                  entities={entities}
                  selectedGroupCode={selectedGroupCode}
                  selectedEntity={selectedEntity}
                  automapValidationMappingModalEnabled={automapValidationMappingModalEnabled}
                  setAutomapValidationMappingModalEnabled={
                    setAutomapValidationMappingModalEnabled
                  }
              />
              <Modal
                  title={t("Page.Operation.ValidationRules.Modals.CopyMappings.Title", {
                    lngs: i18n.languages,
                    defaultValue: "Copy Mappings",
                  })}
                  visible={copyMappingsModalEnabled}
                  onOk={handleCopyMappingsOk}
                  onCancel={() => setCopyMappingsModalEnabled(false)}
                  confirmLoading={loading}
              >
                <div>
                  <label>{t("Page.Operation.ValidationRules.Modals.CopyMappings.FromGroupCode", {
                    lngs: i18n.languages,
                    defaultValue: "From Group code:",
                  })}</label>
                  <Select value={copyMappingSourceGroupCode}
                          style={{width: "100%", marginBottom: "10px"}}
                          onChange={(value) => setCopyMappingSourceGroupCode(value)}>
                      {groupCodes.map((code) => (
                          <Select.Option key={code.id} value={code.code}>
                              {code.code}
                          </Select.Option>
                      ))}
                  </Select>
                </div>
                <div>
                  <label>{t("Page.Operation.ValidationRules.Modals.CopyMappings.FromEntity", {
                    lngs: i18n.languages,
                    defaultValue: "From Entity:",
                  })}</label>
                  <Select value={selectedEntity} disabled style={{width: "100%", marginBottom: "10px"}}>
                    {entities.map((entity) => (
                        <Select.Option key={entity.id} value={entity.id}>
                          {entity.name}
                        </Select.Option>
                    ))}
                  </Select>
                </div>
                <div>
                  <label>{t("Page.Operation.ValidationRules.Modals.CopyMappings.ToGroupCode", {
                    lngs: i18n.languages,
                    defaultValue: "To Group code:",
                  })}</label>
                  <Select
                      style={{width: "100%", marginBottom: "10px"}}
                      value={copyMappingTargetGroupCode}
                      onChange={(value) => setCopyMappingTargetGroupCode(value)}
                  >
                    {groupCodes.map((code) => (
                        <Select.Option key={code.id} value={code.code}>
                          {code.code}
                        </Select.Option>
                    ))}
                  </Select>
                </div>
                <div>
                  <Checkbox
                      style={{width: "100%", marginBottom: "10px"}}
                      onChange={(e) => setOverwriteExistingMappings(e.target.checked)}
                  >
                    {t("Page.Operation.ValidationRules.Modals.CopyMappings.OverwriteExistingMappings", {
                      lngs: i18n.languages,
                      defaultValue: "Overwrite existing mappings?",
                    })}
                  </Checkbox>
                </div>
              </Modal>
            </TabPane>
            <TabPane
                tab={t("Page.Operation.ValidationRules.Tabs.ValidationRules", {
                  lngs: i18n.languages,
                  defaultValue: "Validation Rules",
                })}
                key="validation-rules"
            >
              <Rules
                  entities={entities}
                  groupCodes={groupCodes}
                  selectedEntity={selectedEntity}
                  selectedGroupCode={selectedGroupCode}
                  selectable={false}
                  multiSelect={false}
                  selectedRows={[]}
                  setSelectedRows={undefined}
                  newValidationRuleModalEnabled={newValidationRuleModalEnabled}
                  setNewValidationRuleModalEnabled={
                    setNewValidationRuleModalEnabled
                  }
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
  );
};

export default ValidationRules;